import { render, staticRenderFns } from "./InvestigationDetail.vue?vue&type=template&id=269dc980&"
import script from "./InvestigationDetail.vue?vue&type=script&lang=js&"
export * from "./InvestigationDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports